import React from "react";
import { Controller } from "react-hook-form";
import { Box, Stack, Checkbox, Typography } from "@mui/material";
import { IFormField } from "../../../models/app";

interface Props extends IFormField {
    errors: any;
    watch: any;
    control: any;
    defaultValue?: any;
    onChange?: (e: any) => void;
    setValue?: any;
}

const RHCheckBox: React.FC<Props> = ({ label, name, disabled, control, defaultValue, hidden, watch, onChange, setValue }) => {
    return (
        <Box display={hidden ? "none" : 'flex'} flexDirection={'row'} alignItems={'center'}  my={2}>
            <Typography component="label" htmlFor={`${name}`}>
                {label}
            </Typography>
            <Box sx={{ ml: 5 }}>
                <Controller
                    control={control}
                    name={name}
                    render={({ field }) => (
                        <Stack direction="row" spacing={2} alignItems="center" mx={2}>
                            <Checkbox
                                inputProps={{ 'aria-label': 'checkbox' }}
                                name={field.name}
                                onChange={(e) => {
                                    field.onChange(e.target.checked);
                                    onChange && onChange(e.target.checked);
                                }}
                                onBlur={field.onBlur}
                                ref={field.ref}
                                disabled={disabled}
                                checked={Boolean(field.value ?? defaultValue)}
                            />
                        </Stack>
                    )}
                />
            </Box>
        </Box>
    );
};

export default RHCheckBox;
